const OrderedProductStatus = {
  ON_HOLD: 'OnHold',
  UNDER_PREPARATION: 'UnderPreparation',
  DONE: 'Done',
  DELIVERED: 'Delivered'
}

export default OrderedProductStatus
